import PropTypes from "prop-types";

export const CHOICE_SHAPE = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  description: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
});
